import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03ae545e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nowrap" }


export default /*#__PURE__*/_defineComponent({
  __name: 'NoWrapText',
  props: {
    val: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.val), 1))
}
}

})